import { useContext, useEffect, useRef, useState } from "react";
import { Container } from "react-bootstrap";
import { MyContext } from "../../Context/MyContext";
import site from "../../data/site";
import { BOOK_EVENT, consumeBookRequest } from "../../lib/bookCall";
import classes from "./BookACall.module.css";

const CALENDLY_SCRIPT = "https://assets.calendly.com/assets/external/widget.js";

const calendlyUrl = (theme) =>
  theme === "dark"
    ? "https://calendly.com/haroonabsar3/30min?hide_gdpr_banner=1&background_color=070b14&text_color=f4f7fb&primary_color=148af8"
    : "https://calendly.com/haroonabsar3/30min?hide_gdpr_banner=1&background_color=f7f9fc&text_color=0b1220&primary_color=148af8";

function mountWidget(container, url) {
  if (!container || !window.Calendly?.initInlineWidget) return;
  container.innerHTML = "";
  window.Calendly.initInlineWidget({
    url,
    parentElement: container,
  });
}

export default function BookACall() {
  const { appointmentRef, theme } = useContext(MyContext);
  const embedRef = useRef(null);
  const [active, setActive] = useState(false);

  useEffect(() => {
    const open = () => {
      consumeBookRequest();
      setActive(true);
    };
    if (consumeBookRequest()) setActive(true);
    window.addEventListener(BOOK_EVENT, open);
    return () => window.removeEventListener(BOOK_EVENT, open);
  }, []);

  useEffect(() => {
    if (!active) return undefined;

    const container = embedRef.current;
    const url = calendlyUrl(theme);

    if (window.Calendly?.initInlineWidget) {
      mountWidget(container, url);
      return undefined;
    }

    let script = document.querySelector(`script[src="${CALENDLY_SCRIPT}"]`);
    const onLoad = () => mountWidget(container, url);

    if (!script) {
      script = document.createElement("script");
      script.src = CALENDLY_SCRIPT;
      script.async = true;
      document.body.appendChild(script);
    }

    script.addEventListener("load", onLoad);
    return () => script.removeEventListener("load", onLoad);
  }, [active, theme]);

  return (
    <section
      ref={appointmentRef}
      className={`sectionShell ${classes.section}`}
      id="book-appointment"
    >
      <Container>
        <div className={classes.intro}>
          <div className="sectionEyebrow">Book a call</div>
          <h2 className="sectionTitle">Pick a time that works</h2>
          <p className="sectionLead">
            A 30-minute call to talk through what you need and the fastest way
            to ship it. We are a fully remote team based in Islamabad,
            Pakistan.
          </p>
          <div className={classes.contacts}>
            <a className={classes.email} href={`tel:${site.phone}`}>
              {site.phoneDisplay}
            </a>
            <a className={classes.email} href={`mailto:${site.email}`}>
              {site.email}
            </a>
          </div>
        </div>
        {active ? (
          <div
            ref={embedRef}
            className={classes.embed}
            style={{ minWidth: "320px", height: "700px" }}
          />
        ) : (
          <div className={classes.placeholder}>
            <p>
              The scheduling calendar stays unloaded until you open it, so the
              rest of the page can load first.
            </p>
            <button type="button" className="buttonHome" onClick={() => setActive(true)}>
              Show available times
            </button>
          </div>
        )}
      </Container>
    </section>
  );
}
